import { defineMessages } from "react-intl";

const VALIDATION_RESULT = "validation-result";

const validationResultMessages = defineMessages({
  mergeAccountData: {
    id: `${VALIDATION_RESULT}.merge-account-data`,
    defaultMessage: `Merge user account data from "{sourceAccount}" with "{targetAccount}".`
  },
  mergeAccount: {
    id: `${VALIDATION_RESULT}.merge-account`,
    defaultMessage: "Merge account"
  },
  currentAccount: {
    id: `${VALIDATION_RESULT}.current-account`,
    defaultMessage: "Current account:"
  },
  secondaryAccount: {
    id: `${VALIDATION_RESULT}.secondary-account`,
    defaultMessage: "Secondary account:"
  }
});

export default validationResultMessages;
